import { SvgBase } from "../svg.base";

export const RightArrow = () => (
  <SvgBase
    width="6"
    height="8"
    viewBox="0 0 6 8"
  >
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M1.173 7.946l3.739-3.185a1 1 0 0 0 0-1.522L1.173.054a.365.365 0 0 0-.515.514l2.361 2.785a1 1 0 0 1 0 1.294L.658 7.432a.365.365 0 0 0 .515.514z"
    />
  </SvgBase>
);